import classNames from 'classnames';
import { Heading, RichText, Link, LinkButton } from 'ui/components';
import styles from './InternalLinkbox.module.scss';

export interface InternalLinkboxProps {
    className?: string;
    heading?: string;
    linkboxItems?: { text: string; anchorLink: string }[];
	roundButtons: boolean
    backgroundColor?: string;
	textColor?: string;
	buttonColor?: string;
    ctaLink?: Content.Link | null;
}

export const InternalLinkbox: React.FC<InternalLinkboxProps> = ({
    className,
    heading,
    linkboxItems,
	roundButtons = false,
    backgroundColor = 'transparent',
	textColor,
	buttonColor,
    ctaLink
}) => {
    return (
            <div
                className={classNames(styles.InternalLinkbox, className)}
                style={
                {
                    backgroundColor: backgroundColor ? backgroundColor : 'transparent',
					...(textColor ? { '--InternalLinkbox-text-color': textColor } : {}),
					...(buttonColor ? { '--color-primary': buttonColor } : {})
                } as React.CSSProperties
            }
            >
				<RichText 
                            className={classNames(styles.InternalLinkbox_heading)}
                            content={heading} 
                            textColor={textColor}
                        />

                {linkboxItems && (
                    <div className={classNames(styles.InternalLinkbox_buttonsContainer)}>
                        {linkboxItems.map((linkboxItem, index) => (
                            <LinkButton
                                key={index}
                                ariaLabel={linkboxItem?.text}
                                url={linkboxItem.anchorLink}
                                className={classNames(styles.InternalLinkbox_button)}
                                target="_self"
                                style={roundButtons ? 'primarySmall' : 'primarySmallSquare'}
                            >
                                {linkboxItem?.text}
                            </LinkButton>
                        ))}
                    </div>
                )}

                {ctaLink && (
                    <div className={styles.InternalLinkbox_ctaWrapper}>
                        <Link
                            url={ctaLink.url}
                            className={styles.InternalLinkbox_ctaLink}
                        >
                            {ctaLink.name}
                        </Link>
                    </div>
                )}
            </div>
    );
};
